import fetch from './fetch';


const queryCharts = (data) => {
    return fetch.post('course/target/analysis/query', data)
    .then(res => {
        if(res.code === 200) {
            return {
                dataSource: res.payload.data,
            }
        }
        return {
            dataSource:[],
        }
    })
}

const queryTargetByType1 = () => {
    return fetch.get('course/target/analysis/queryTargetByType1')
    .then(res => {
        if(res.code === 200) {
            return res.payload.data;
        }
    })
}

const queryTarget3ByTargetIdType1Id = (targetType1Id) => {
    return fetch.get('course/target/analysis/queryTarget3ByTargetIdType1Id/' + targetType1Id)
    .then(res => {
        if(res.code === 200) {
            return res.payload.data;
        }
    })
}

export default {
    queryCharts,
    queryTargetByType1,
    queryTarget3ByTargetIdType1Id
}